"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Drawer =
/*#__PURE__*/
function (_Utility) {
  _inherits(Drawer, _Utility);

  function Drawer() {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Drawer).call(this));
    _this.isStatus = 'close';
    _this.isAvailMenuBtn = true;
    _this.elBody = document.querySelector('body');
    _this.elToggleBtn = document.querySelector('.toggle-btn');
    _this.elCloseBtn = document.querySelector('.close-btn');
    _this.winW = window.innerWidth;
    _this.scrollFixed = 0;
    _this.beforTopPos = 0;

    _this.setListener();

    return _this;
  }

  _createClass(Drawer, [{
    key: "close",
    value: function close() {
      var _this2 = this;

      //console.log('close');
      this.removeClass(this.elBody, 'nav-open');
      this.addClass(this.elBody, 'nav-close'); //子メニューのeventをoff
      // $('.menu-item-has-children').off();
      // スクロールの有効化

      var targetEl = ['body', 'html', '.site', '.main-navigation', '.pagetop', '.toggle-btn', '.site-content'];
      this.removeAttr(targetEl, 'style');
      window.scrollTo(0, this.scrollFixed); //レイヤーを削除

      this.fade(document.querySelector('.menu-layer'), 500, 'out', function () {
        //callback
        //console.log('fadeout');
        document.querySelector('.menu-layer').remove();
        _this2.isStatus = 'close';
        _this2.isAvailMenuBtn = true;
      }); //header固定
      // if(topPos < 90) $('.site-header').removeClass('fixed');
    }
  }, {
    key: "open",
    value: function open() {
      var _this3 = this;

      //console.log('open');
      if (!this.hasClass('.site-header', 'fixed')) {
        this.addClass('.site-header', 'fixed');
      }

      this.timer(650).then(function () {
        //console.log("menu open 終了");
        _this3.isStatus = 'open';
        _this3.isAvailMenuBtn = true;
      }); //背景のスクロールを固定

      this.winW = window.innerWidth;
      this.scrollFixed = document.documentElement.scrollTop || document.body.scrollTop;
      document.querySelector('.site-content').setAttribute('style', 'position:relative;top:' + -1 * this.scrollFixed + 'px;'); //スクロールバーの幅の分、トグルボタンとページトップを位置調整する

      var paddingR = this.winW - document.body.clientWidth;

      if (paddingR > 0) {
        var bodyPaddingR = "padding-right:".concat(paddingR, "px;");
        this.setAttr(['body'], 'style', bodyPaddingR);
        var pagetopRight = 0;

        if (document.querySelector('.pagetop') !== null) {
          pagetopRight = this.getStyleValue('.pagetop', 'right');
          pagetopRight = parseInt(pagetopRight) + paddingR;
          document.querySelector('.pagetop').style.right = "".concat(pagetopRight, "px");
        }

        var toggleRight = 0;

        if (document.querySelector('.toggle-btn') !== null) {
          toggleRight = this.getStyleValue('.toggle-btn', 'right');
          toggleRight = parseInt(toggleRight) + paddingR;
          document.querySelector('.toggle-btn').style.right = "".concat(toggleRight, "px");
        }
      } // スクロールの無効化


      this.setAttr(['body', 'html'], 'style', 'overflow:hidden;height:100%;');
      this.beforTopPos = this.scrollFixed; //背面レイヤーの作成

      var layer = document.createElement('div');
      layer.classList.add('menu-layer');
      var elements = document.getElementsByClassName('menu-layer');

      if (elements.length > 0) {
        document.querySelector('.menu-layer').remove();
      }

      document.querySelector('.main-navigation').appendChild(layer);
      this.fade(document.querySelector('.menu-layer'), 300, 'in', function () {
        //callback
        //console.log('fadein');
        //this.scrollFixed = topPos;
        document.querySelector('.menu-layer').addEventListener('click', function (el) {
          _this3.toggleMenu();
        });
      }); //遅延させてからメニューを開く

      this.timer(50).then(function () {
        _this3.removeClass(_this3.elBody, 'nav-close');

        _this3.addClass(_this3.elBody, 'nav-open');
      }); //子メニュー開閉
      // $('.menu-item-has-children').on('click touch', function () {
      //   $(this).toggleClass('open-sub-menu');
      // });
    }
  }, {
    key: "setListener",
    value: function setListener() {
      var _this4 = this;

      if (this.elToggleBtn !== null) {
        //メニュー開閉ボタン
        this.elToggleBtn.addEventListener('click', function (el) {
          _this4.toggleMenu();
        }); //メニュー内closeボタン
        // this.elCloseBtn.addEventListener('click',(el) => {
        //   this.toggleMenu();
        // });
        //ページ内リンクをclickで閉じる

        _toConsumableArray(document.querySelectorAll('.main-navigation a')).forEach(function (el, index) {
          var link = _this4.getAttr(el, 'href');

          if (link.startsWith('#')) {
            el.addEventListener('click', function (elBtn) {
              if (_this4.isStatus === 'open') {
                _this4.toggleMenu();
              }
            });
          }
        });
      }
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      if (this.isAvailMenuBtn) {
        this.isAvailMenuBtn = false;
        this.toggleClass(this.elToggleBtn, 'is-open');

        if (this.isStatus === 'open') {
          //閉じる
          this.close();
        } else {
          this.open();
        }
      }
    }
  }]);

  return Drawer;
}(Utility);